<template>
  <div class="tabbar3">还没开发呢！！！！</div>
</template>
<script>
import data from "@/data/tabbar3_data.js";
// const show1 = () => import("@/components/show/show1.vue");
export default {
  name: "tabbar3",
  components: {
    // 组件注册
    // show1
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
    // Vue实例渲染完成后执行
  },
};
</script>
<style scoped lang="scss">
@import url("~@/assets/icon/iconfont.css");
@import url("~@/assets/css/tabbar3/tabbar3.scss");
</style>
